

































import { Vue, Component } from 'vue-property-decorator'
import { Dialog, Button } from 'mand-mobile'
import store from '@/store'

@Component({ components: { [Button.name]: Button } })
export default class Home extends Vue {
  bizToken: any = null
  isAllowUpload: boolean = true

  startHandler() {
    this.$router.push({ name: 'pcRecord', query: { biz_token: this.bizToken, fromName: this.$route.query.from } })
  }
  mounted() {
    this.bizToken = this.$route.query.biz_token
    store.bizToken = this.$route.query.biz_token as string
    if (!this.bizToken) {
      this.isAllowUpload = false
      return
    }
  }
}
